import { isGeoPointValid } from '@@partner:helpers/util'
import { GeoPoint, Shop } from '@@partner:types:app'
import MapMarker from '@components/common/MapMarker'
import L, {
  LatLngLiteral, 
  Marker as LeafletEditableMarker,
  Map as LeafletMap, 
} from 'leaflet'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { MapContainer, Marker, TileLayer } from 'react-leaflet'

type props = {
  geoPoint?: GeoPoint
  shop?: Shop
  onPositionChanged: (point: GeoPoint) => void
}

export const DEFAULT_MAP_CENTER: GeoPoint = {
  latitude: 54.326044,
  longitude: 48.480974
}

const convertGeoPointToLeafletLatLng = (point: GeoPoint): LatLngLiteral => ({
  lat: point.latitude as number,
  lng: point.longitude as number
})


const convertLeafletLatLngToGeoPoint = (
  latLngExpr: LatLngLiteral
): GeoPoint => ({
  latitude: latLngExpr.lat,
  longitude: latLngExpr.lng
})


export default function ShopMarker ({
  geoPoint,
  onPositionChanged
}: props) {
  const markerRef = useRef<LeafletEditableMarker>(null)
  const [ markerPosition, setMarkerPosition ] = useState(
    convertGeoPointToLeafletLatLng(isGeoPointValid(geoPoint) && geoPoint ? geoPoint : DEFAULT_MAP_CENTER)
  )
  const [ map, setMap ] = useState<LeafletMap>()
  const marker = markerRef.current

  useEffect(() => {
    if (geoPoint && geoPoint.latitude && geoPoint.longitude && !!map) {
      const newPosition = convertGeoPointToLeafletLatLng(geoPoint)
      setMarkerPosition(newPosition)
      if (markerPosition.lat !== newPosition.lat || markerPosition.lng !== newPosition.lng) {
        map?.setView(newPosition, 12)
      }
    }
  }, [ geoPoint, map ])

  const handleMarkerDragEnd = useCallback(() => {
    if (marker != null) {
      const markerLatLng = marker.getLatLng()
      setMarkerPosition(markerLatLng)
      onPositionChanged?.(convertLeafletLatLngToGeoPoint(markerLatLng))
    }
  }, [ marker, onPositionChanged ])

  const whenMapCreated = (map: LeafletMap) => {
    setMap(map)
  }
  
  return (
    <MapContainer
      center={markerPosition}
      position={markerPosition}
      zoom={12}
      scrollWheelZoom={true}
      whenCreated={whenMapCreated}
      editable={true}
      style={{
        height: 400,
        width: '100%'
      }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <button>
        Test
      </button>
      { !!markerPosition && (
        <Marker
          icon={MapMarker('red')}
          position={markerPosition}
          draggable
          eventHandlers={{
            dragend: handleMarkerDragEnd
          }}
          ref={markerRef}
        />
      )}

    </MapContainer>
  )
}